/* YOBY site locale: detect, persist, translate home/nav, slug routing for posts/pages */
(function () {
    var STORAGE_KEY = 'paperverso_locale';
    var LOCALES = window.YOBY_SUPPORTED_LOCALES || ['it', 'fr', 'es', 'pt', 'en', 'de', 'nl'];
    var MESSAGES = window.YOBY_SITE_LOCALES || {};
    var NAV_CONFIG = window.YOBY_NAV_CONFIG || { mainNav: [], footerColumns: {} };

    /** Slug/URL fissi — mai tradotti (dashboard scuola, status, play). */
    var CANONICAL_SLUGS = ['accessibility', 'teacher', 'supervisor', 'admin-school', 'status', 'massmail', 'conference', 'talk-with-us', 'school-signup', 'redteam', 'admin-safety'];
    var CANONICAL_PATHS = ['/accessibility', '/teacher', '/supervisor', '/admin-school', '/admin/school', '/status', '/redteam', '/admin-safety', '/massmail', '/conference', '/talk-with-us', '/school-signup', '/prenota', '/play', '/claim'];

    function isCanonicalSlug(base) {
        return CANONICAL_SLUGS.indexOf(base) >= 0;
    }

    function isCanonicalPath(pathname) {
        var p = normalizePath(pathname);
        for (var i = 0; i < CANONICAL_PATHS.length; i += 1) {
            if (p === CANONICAL_PATHS[i]) return true;
        }
        return false;
    }

    /** /it-talk-with-us → /talk-with-us/ (stesso per conference, teacher, …). */
    function canonicalPathForBase(base) {
        return '/' + base + '/';
    }

    function localizedCanonicalRedirectTarget(pathname) {
        var p = normalizePath(pathname);
        var m = /^\/([a-z]{2})-(.+)$/.exec(p);
        if (!m) return null;
        var loc = m[1];
        var base = m[2];
        if (LOCALES.indexOf(loc) < 0 || loc === 'en') return null;
        if (!isCanonicalSlug(base)) return null;
        return canonicalPathForBase(base);
    }

    var FOOTER_LABEL_KEYS = {
        about: 'footer.col.about',
        safety: 'footer.col.safety',
        accessibility: 'footer.col.accessibility',
        aiAudits: 'footer.col.aiAudits',
        schools: 'footer.col.schools',
        schoolSignup: 'nav.footer.schoolSignup',
        banksAndPartners: 'footer.col.banksAndPartners',
        roadmap: 'footer.col.roadmap',
        press: 'footer.col.press',
        investors: 'footer.col.investors',
        contact: 'footer.col.contact',
        privacyPolicy: 'footer.col.privacyPolicy',
        termsOfService: 'footer.col.termsOfService',
        cookiePolicy: 'footer.col.cookiePolicy',
        parentalControls: 'footer.col.parentalControls',
        dataAndGdpr: 'footer.col.dataAndGdpr',
        genderEquality: 'footer.col.genderEquality'
    };

    function normalizeLocale(input) {
        if (!input) return 'en';
        var key = String(input).trim().toLowerCase().replace(/_/g, '-');
        if (LOCALES.indexOf(key) >= 0) return key;
        var base = key.split('-')[0];
        if (LOCALES.indexOf(base) >= 0) return base;
        var aliases = {
            'pt-br': 'pt', 'pt-pt': 'pt', 'en-us': 'en', 'en-gb': 'en',
            'it-it': 'it', 'fr-fr': 'fr', 'es-es': 'es', 'de-de': 'de', 'nl-nl': 'nl', 'nl-be': 'nl'
        };
        return aliases[key] || aliases[base] || 'en';
    }

    function getStoredLocale() {
        try {
            var v = localStorage.getItem(STORAGE_KEY);
            return v && LOCALES.indexOf(v) >= 0 ? v : null;
        } catch (e) {
            return null;
        }
    }

    function setStoredLocale(locale) {
        try {
            localStorage.setItem(STORAGE_KEY, locale);
        } catch (e) { /* ignore */ }
    }

    function detectInitialLocale() {
        var stored = getStoredLocale();
        if (stored) return stored;
        var detected = normalizeLocale(navigator.language || navigator.userLanguage);
        setStoredLocale(detected);
        return detected;
    }

    function getActiveLocale() {
        return getStoredLocale() || detectInitialLocale();
    }

    function slugLocale(slug) {
        if (!slug) return null;
        for (var i = 0; i < LOCALES.length; i += 1) {
            var loc = LOCALES[i];
            if (loc === 'en') continue;
            var prefix = loc + '-';
            if (slug === loc || slug.indexOf(prefix) === 0) return loc;
        }
        return null;
    }

    function getBaseSlug(slug) {
        if (!slug) return '';
        var loc = slugLocale(slug);
        if (!loc) return slug;
        if (slug === loc) return '';
        return slug.slice(loc.length + 1);
    }

    function pageUrl(baseSlug, locale) {
        if (baseSlug === 'home') return '/';
        if (baseSlug === 'blog') {
            // EN listing = /blog/; other locales = Ghost tag archives (never it-blog / de-blog).
            if (locale !== 'en') return '/tag/' + locale + '/';
            return '/blog/';
        }
        if (isCanonicalSlug(baseSlug)) return '/' + baseSlug + '/';
        if (locale === 'en') return '/' + baseSlug + '/';
        return '/' + locale + '-' + baseSlug + '/';
    }

    function isBlogArchivePath(pathname) {
        var p = normalizePath(pathname);
        if (p === '/blog') return true;
        var m = /^\/tag\/([a-z]{2})$/.exec(p);
        if (!m) return false;
        return LOCALES.indexOf(m[1]) >= 0 && m[1] !== 'en';
    }

    /** Vecchie pagine Ghost tipo /de-blog/ → archivio tag. */
    function legacyBlogPageLocale(pathname) {
        var p = normalizePath(pathname);
        var m = /^\/([a-z]{2})-blog$/.exec(p);
        if (!m) return null;
        var loc = m[1];
        if (LOCALES.indexOf(loc) < 0 || loc === 'en') return null;
        return loc;
    }

    function slugCandidates(base, locale) {
        if (locale === 'en') return [base];
        return [locale + '-' + base];
    }

    function t(key, vars) {
        var locale = getActiveLocale();
        // Live lookup: deploy may rebuild locales; avoid stale snapshot from bundle boot.
        var live = window.YOBY_SITE_LOCALES || MESSAGES || {};
        var str = (live[locale] && live[locale][key]) ||
            (live.en && live.en[key]) ||
            key;
        if (vars) {
            Object.keys(vars).forEach(function (k) {
                str = str.split('{' + k + '}').join(String(vars[k]));
            });
        }
        return str;
    }

    function labelKeyForItem(item) {
        if (item.action === 'signin') return 'nav.actions.signIn';
        if (item.action === 'signup') return 'nav.actions.startFree';
        if (FOOTER_LABEL_KEYS[item.id]) return FOOTER_LABEL_KEYS[item.id];
        return 'nav.main.' + item.id;
    }

    function itemHref(item, locale) {
        if (item.action === 'signin') return '#/portal/signin';
        if (item.action === 'signup') return '#/portal/signup';
        return pageUrl(item.slug, locale);
    }

    function normalizePath(path) {
        if (!path) return '/';
        var p = path.split('?')[0].split('#')[0];
        p = p.replace(/\/+$/, '');
        return p || '/';
    }

    function isNavItemActive(href) {
        var current = normalizePath(window.location.pathname);
        var target = normalizePath(href);
        if (target === '/') {
            return current === '/' || document.body.classList.contains('home-template');
        }
        if (target.indexOf('/tag/') === 0) {
            return current === target || current.indexOf(target + '/') === 0;
        }
        if (target === '/blog') {
            return current === '/blog';
        }
        return current === target;
    }

    function createNavLink(item, locale) {
        var a = document.createElement('a');
        var href = itemHref(item, locale);
        a.setAttribute('href', href);
        a.textContent = t(labelKeyForItem(item));
        a.setAttribute('data-nav-id', item.id);
        if (item.action) {
            a.setAttribute('data-portal', item.action);
        }
        if (item.mobileOnly) {
            a.classList.add('yoby-nav-mobile-only');
        }
        if (isNavItemActive(href)) {
            a.classList.add('nav-current');
            a.setAttribute('aria-current', 'page');
        }
        return a;
    }

    function buildMainNav() {
        var ul = document.querySelector('[data-yoby-nav="main"]');
        if (!ul || !NAV_CONFIG.mainNav) return;
        var locale = getActiveLocale();
        ul.innerHTML = '';
        NAV_CONFIG.mainNav.forEach(function (item) {
            var li = document.createElement('li');
            if (item.mobileOnly) li.classList.add('yoby-nav-mobile-only');
            li.appendChild(createNavLink(item, locale));
            ul.appendChild(li);
        });
        var navMenu = ul.closest('.gh-navigation-menu');
        if (navMenu) {
            navMenu.setAttribute('aria-label', t('nav.aria.main'));
        }
    }

    function buildFooterNav() {
        var locale = getActiveLocale();
        Object.keys(NAV_CONFIG.footerColumns || {}).forEach(function (colKey) {
            var col = document.querySelector('[data-yoby-footer-col="' + colKey + '"]');
            if (!col) return;
            var ul = col.querySelector('.yoby-footer-links');
            if (!ul) return;
            ul.innerHTML = '';
            (NAV_CONFIG.footerColumns[colKey] || []).forEach(function (item) {
                var li = document.createElement('li');
                li.appendChild(createNavLink(item, locale));
                ul.appendChild(li);
            });
        });
    }

    function setActiveNav() {
        document.querySelectorAll('.yoby-main-nav a, .yoby-footer-links a').forEach(function (a) {
            var href = a.getAttribute('href') || '';
            var active = isNavItemActive(href);
            a.classList.toggle('nav-current', active);
            if (active) {
                a.setAttribute('aria-current', 'page');
            } else {
                a.removeAttribute('aria-current');
            }
        });
    }

    function applyTranslations() {
        document.querySelectorAll('[data-yoby-i18n]').forEach(function (el) {
            var key = el.getAttribute('data-yoby-i18n');
            if (!key) return;
            var vars = {};
            Array.prototype.forEach.call(el.attributes, function (attr) {
                if (attr.name.indexOf('data-yoby-i18n-') === 0 && attr.name !== 'data-yoby-i18n-vars') {
                    vars[attr.name.slice('data-yoby-i18n-'.length)] = attr.value;
                }
            });
            var varsStr = el.getAttribute('data-yoby-i18n-vars');
            if (varsStr) {
                try { Object.assign(vars, JSON.parse(varsStr)); } catch (e) { /* ignore */ }
            }
            var fallback = (el.textContent || '').trim();
            var translated = t(key, vars);
            // If translation pack is stale/missing, keep any authored fallback text.
            if (translated === key && fallback && fallback !== key) {
                el.textContent = fallback;
            } else {
                el.textContent = translated;
            }
        });

        document.querySelectorAll('[data-yoby-i18n-alt]').forEach(function (el) {
            var key = el.getAttribute('data-yoby-i18n-alt');
            if (key) el.setAttribute('alt', t(key));
        });

        document.querySelectorAll('[data-yoby-i18n-aria]').forEach(function (el) {
            var key = el.getAttribute('data-yoby-i18n-aria');
            if (key) el.setAttribute('aria-label', t(key));
        });

        document.querySelectorAll('[data-yoby-i18n-title]').forEach(function (el) {
            var key = el.getAttribute('data-yoby-i18n-title');
            if (key) el.setAttribute('title', t(key));
        });

        buildMainNav();
        if (window.YOBY_StaffNav) window.YOBY_StaffNav.refresh();
        buildFooterNav();
        setActiveNav();
        applyPageSlugLinks();
        applyCanonicalLinks();
        localizeContentLinks();
        updateSwitcherState();
        applyHomeSeo();
        if (document.querySelector('.yoby-accessibility-page')) document.title = t('accessibility.title');
        updateSwitcherState();
    }

    function applyHomeSeo() {
        if (!document.body.classList.contains('home-template')) return;

        var title = t('home.seo.title');
        if (title) document.title = title;

        var desc = t('home.seo.description');
        if (desc) {
            var meta = document.getElementById('yoby-meta-description')
                || document.querySelector('meta[name="description"]');
            if (!meta) {
                meta = document.createElement('meta');
                meta.name = 'description';
                meta.id = 'yoby-meta-description';
                document.head.appendChild(meta);
            }
            meta.setAttribute('content', desc);
        }

        var jsonLdEl = document.getElementById('yoby-home-jsonld');
        if (jsonLdEl && desc) {
            try {
                var graph = JSON.parse(jsonLdEl.textContent);
                if (graph && graph['@graph']) {
                    graph['@graph'].forEach(function (node) {
                        if (node['@type'] === 'Organization' || node['@type'] === 'WebSite') {
                            node.description = desc;
                        }
                    });
                    jsonLdEl.textContent = JSON.stringify(graph);
                }
            } catch (e) { /* ignore */ }
        }

        ['og:title', 'og:description', 'twitter:title', 'twitter:description'].forEach(function (prop) {
            var isTwitter = prop.indexOf('twitter:') === 0;
            var attr = isTwitter ? 'name' : 'property';
            var el = document.querySelector('meta[' + attr + '="' + prop + '"]');
            if (!el) return;
            if (prop.indexOf('title') >= 0 && title) el.setAttribute('content', title);
            if (prop.indexOf('description') >= 0 && desc) el.setAttribute('content', desc);
        });
    }

    function applyCanonicalLinks() {
        document.querySelectorAll('[data-yoby-href-canonical]').forEach(function (el) {
            var href = el.getAttribute('data-yoby-href-canonical');
            if (href) el.setAttribute('href', href);
        });
    }

    function applyPageSlugLinks() {
        var locale = getActiveLocale();
        document.querySelectorAll('[data-yoby-href-slug]').forEach(function (el) {
            var slug = el.getAttribute('data-yoby-href-slug');
            if (!slug) return;
            el.setAttribute('href', pageUrl(slug, locale));
        });
    }

    function isInternalPath(pathname) {
        if (!pathname || pathname === '/') return false;
        if (pathname.indexOf('/play') === 0) return false;
        if (pathname.indexOf('/claim') === 0) return false;
        if (pathname.indexOf('/api/') === 0) return false;
        if (pathname.indexOf('/members/') === 0) return false;
        if (pathname.indexOf('/ghost/') === 0) return false;
        if (pathname.indexOf('/assets/') === 0) return false;
        if (pathname.indexOf('/tag/') === 0) return false;
        return true;
    }

    function localizeHref(href, locale) {
        try {
            var url = new URL(href, window.location.origin);
            if (url.origin !== window.location.origin) return href;
            if (isCanonicalPath(url.pathname)) return href;
            var path = url.pathname.replace(/^\/+|\/+$/g, '');
            if (!path || !isInternalPath('/' + path)) return href;
            var segments = path.split('/');
            var slug = segments[0];
            var base = getBaseSlug(slug);
            if (!base) return href;
            if (isCanonicalSlug(base)) {
                url.pathname = canonicalPathForBase(base);
                if (segments.length > 1) {
                    url.pathname += segments.slice(1).join('/');
                }
                return url.pathname + url.search + url.hash;
            }
            if (base === 'blog') {
                url.pathname = pageUrl('blog', locale);
                return url.pathname + url.search + url.hash;
            }
            var localized = locale === 'en' ? base : locale + '-' + base;
            url.pathname = '/' + localized + '/';
            if (segments.length > 1) {
                url.pathname += segments.slice(1).join('/');
            }
            return url.pathname + url.search + url.hash;
        } catch (e) {
            return href;
        }
    }

    function localizeContentLinks() {
        var locale = getActiveLocale();
        document.querySelectorAll('.gh-content a[href], .gh-feed a[href], .gh-card a[href]').forEach(function (a) {
            if (a.hasAttribute('data-yoby-href-canonical')) return;
            var href = a.getAttribute('href');
            if (!href || href.charAt(0) === '#') return;
            var localized = localizeHref(href, locale);
            if (localized !== href) a.setAttribute('href', localized);
        });
    }

    function updateSwitcherState() {
        var locale = getActiveLocale();
        document.documentElement.lang = locale;
        var activeOpt = null;
        document.querySelectorAll('.yoby-lang-option').forEach(function (btn) {
            var loc = btn.getAttribute('data-locale');
            var active = loc === locale;
            btn.classList.toggle('is-active', active);
            btn.setAttribute('aria-selected', active ? 'true' : 'false');
            if (active) activeOpt = btn;
        });
        document.querySelectorAll('.yoby-lang-switcher').forEach(function (root) {
            var trigger = root.querySelector('.yoby-lang-trigger');
            var flagEl = root.querySelector('.yoby-lang-trigger-flag');
            var labelEl = root.querySelector('.yoby-lang-trigger-label');
            if (!trigger || !activeOpt) return;
            var flag = activeOpt.querySelector('.yoby-lang-option-flag');
            var label = activeOpt.getAttribute('data-label') || activeOpt.getAttribute('aria-label') || locale;
            if (flagEl && flag) flagEl.textContent = flag.textContent;
            if (labelEl) labelEl.textContent = label;
            trigger.setAttribute('aria-label', (window.YOBY_i18n && window.YOBY_i18n.t('lang.switch')) || 'Language');
        });
    }

    function closeLangMenus() {
        document.querySelectorAll('.yoby-lang-switcher').forEach(function (root) {
            var trigger = root.querySelector('.yoby-lang-trigger');
            var menu = root.querySelector('.yoby-lang-menu');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
            if (menu) menu.hidden = true;
            root.classList.remove('is-open');
        });
    }

    function initLanguageSwitcher() {
        var roots = document.querySelectorAll('.yoby-lang-switcher');
        if (!roots.length) return;

        roots.forEach(function (root) {
            var trigger = root.querySelector('.yoby-lang-trigger');
            var menu = root.querySelector('.yoby-lang-menu');
            if (!trigger || !menu) return;

            trigger.addEventListener('click', function (e) {
                e.stopPropagation();
                var open = trigger.getAttribute('aria-expanded') === 'true';
                closeLangMenus();
                if (!open) {
                    trigger.setAttribute('aria-expanded', 'true');
                    menu.hidden = false;
                    root.classList.add('is-open');
                }
            });

            root.querySelectorAll('.yoby-lang-option').forEach(function (btn) {
                btn.addEventListener('click', function (e) {
                    e.stopPropagation();
                    var locale = btn.getAttribute('data-locale');
                    closeLangMenus();
                    if (!locale || locale === getActiveLocale()) return;
                    navigateToLocale(locale);
                });
            });
        });

        document.addEventListener('click', function () {
            closeLangMenus();
        });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') closeLangMenus();
        });

        updateSwitcherState();
    }

    function firstExistingSlug(candidates) {
        var i = 0;
        function tryNext() {
            if (i >= candidates.length) return Promise.resolve(null);
            var slug = candidates[i];
            i += 1;
            return fetch('/' + slug + '/', { method: 'HEAD', redirect: 'follow' })
                .then(function (res) {
                    if (res.ok) return slug;
                    return tryNext();
                })
                .catch(function () { return tryNext(); });
        }
        return tryNext();
    }

    function notifyLocaleChange() {
        try {
            window.dispatchEvent(new CustomEvent('yoby:localechange', { detail: { locale: getActiveLocale() } }));
        } catch (e) { /* ignore */ }
        if (window.YOBY_SchoolDashboard && typeof window.YOBY_SchoolDashboard.onLocaleChange === 'function') {
            window.YOBY_SchoolDashboard.onLocaleChange();
        }
        if (window.YOBY_portalI18n && typeof window.YOBY_portalI18n.apply === 'function') {
            window.YOBY_portalI18n.apply();
        }
    }

    function navigateToLocale(locale) {
        setStoredLocale(locale);
        document.documentElement.lang = locale;

        if (isBlogArchivePath(window.location.pathname)) {
            var blogDest = pageUrl('blog', locale);
            if (normalizePath(blogDest) !== normalizePath(window.location.pathname)) {
                window.location.href = blogDest;
                return;
            }
            applyTranslations();
            notifyLocaleChange();
            return;
        }

        var metaEl = document.getElementById('yoby-page-meta');
        if (!metaEl) {
            applyTranslations();
            notifyLocaleChange();
            return;
        }

        var meta;
        try { meta = JSON.parse(metaEl.textContent); } catch (e) { meta = null; }
        if (!meta || !meta.slug) {
            applyTranslations();
            notifyLocaleChange();
            return;
        }

        var base = getBaseSlug(meta.slug);
        if (!base) {
            applyTranslations();
            notifyLocaleChange();
            return;
        }
        if (isCanonicalSlug(base)) {
            applyTranslations();
            notifyLocaleChange();
            return;
        }
        if (base === 'blog') {
            var dest = pageUrl('blog', locale);
            if (normalizePath(dest) !== normalizePath(window.location.pathname)) {
                window.location.href = dest;
            } else {
                applyTranslations();
                notifyLocaleChange();
            }
            return;
        }

        firstExistingSlug(slugCandidates(base, locale)).then(function (slug) {
            if (slug && slug !== meta.slug) {
                window.location.href = '/' + slug + '/';
            } else {
                applyTranslations();
                notifyLocaleChange();
            }
        });
    }

    function maybeRedirectOnLoad() {
        var legacyLoc = legacyBlogPageLocale(window.location.pathname);
        if (legacyLoc) {
            window.location.replace('/tag/' + legacyLoc + '/');
            return;
        }

        var canonicalDest = localizedCanonicalRedirectTarget(window.location.pathname);
        if (canonicalDest) {
            window.location.replace(
                canonicalDest + (window.location.search || '') + (window.location.hash || ''),
            );
            return;
        }

        if (isBlogArchivePath(window.location.pathname)) {
            var localeOnBlog = getActiveLocale();
            var expectedBlog = pageUrl('blog', localeOnBlog);
            if (normalizePath(expectedBlog) !== normalizePath(window.location.pathname)) {
                window.location.replace(expectedBlog);
            }
            return;
        }

        var metaEl = document.getElementById('yoby-page-meta');
        if (!metaEl) return;

        var meta;
        try { meta = JSON.parse(metaEl.textContent); } catch (e) { return; }
        if (!meta || !meta.slug) return;

        var locale = getActiveLocale();
        var base = getBaseSlug(meta.slug);
        if (!base) return;
        if (isCanonicalSlug(base)) {
            // Ghost may still serve translated pages (it-talk-with-us, …): force bare slug.
            if (meta.slug !== base) {
                window.location.replace(
                    canonicalPathForBase(base) +
                    (window.location.search || '') +
                    (window.location.hash || ''),
                );
            }
            return;
        }
        if (base === 'blog') {
            var dest = pageUrl('blog', locale);
            if (normalizePath(dest) !== normalizePath(window.location.pathname)) {
                window.location.replace(dest);
            }
            return;
        }

        var currentLoc = slugLocale(meta.slug);
        if (currentLoc === locale || (currentLoc === null && locale === 'en')) return;

        var expected = locale === 'en' ? base : locale + '-' + base;
        if (meta.slug === expected) return;

        firstExistingSlug(slugCandidates(base, locale)).then(function (slug) {
            if (slug && slug !== meta.slug) {
                window.location.replace('/' + slug + '/');
            }
        });
    }

    var FIRST_TOUCH_KEY = 'yoby_first_touch';

    function firstNonEmpty(cur, next) {
        var c = String(cur || '').trim();
        if (c) return c.slice(0, 500);
        return String(next || '').trim().slice(0, 500);
    }

    function captureFirstTouch() {
        try {
            var params = new URLSearchParams(window.location.search);
            var stored = null;
            try { stored = JSON.parse(sessionStorage.getItem(FIRST_TOUCH_KEY) || 'null'); } catch (e) { stored = null; }
            if (!stored || typeof stored !== 'object') stored = {};
            var next = {
                referrer: firstNonEmpty(stored.referrer, document.referrer),
                landingUrl: firstNonEmpty(stored.landingUrl, window.location.href),
                source: firstNonEmpty(stored.source, params.get('source')),
                campaign: firstNonEmpty(stored.campaign, params.get('campaign')),
                ref: firstNonEmpty(stored.ref, params.get('ref')),
                utmSource: firstNonEmpty(stored.utmSource, params.get('utm_source')),
                utmMedium: firstNonEmpty(stored.utmMedium, params.get('utm_medium')),
                utmCampaign: firstNonEmpty(stored.utmCampaign, params.get('utm_campaign')),
                utmContent: firstNonEmpty(stored.utmContent, params.get('utm_content')),
                utmTerm: firstNonEmpty(stored.utmTerm, params.get('utm_term')),
            };
            sessionStorage.setItem(FIRST_TOUCH_KEY, JSON.stringify(next));
            window.YOBY_firstTouch = next;
        } catch (e) { /* ignore */ }
    }

    window.YOBY_i18n = {
        getLocale: getActiveLocale,
        setLocale: navigateToLocale,
        t: t,
        pageUrl: pageUrl,
        getBaseSlug: getBaseSlug
    };

    captureFirstTouch();
    detectInitialLocale();
    document.documentElement.lang = getActiveLocale();

    document.addEventListener('DOMContentLoaded', function () {
        initLanguageSwitcher();
        applyTranslations();
        notifyLocaleChange();
        maybeRedirectOnLoad();
    });
})();
